import { render, staticRenderFns } from "./RemortgageClientQuestionnaire.vue?vue&type=template&id=4afe2d92&"
import script from "./RemortgageClientQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./RemortgageClientQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports